// extracted by mini-css-extract-plugin
export default {"ProfileContainer":"StudentProfile_ProfileContainer__dgxSE"};